  export function listarDebitos() {

    const listCategoria = [
        { id: 1, name: 'Casa' },
        { id: 2, name: 'Investimentos' },
        { id: 3, name: 'Responsabilidade' },
        { id: 4, name: 'Pessoal' },
        { id: 5, name: 'Dívida' }, 
        { id: 6, name: 'Pet' }, 

      ];

    return listCategoria;
  }
  
  export function listarSituacao() {

    const listSituacao = [
        { id: 1, name: 'Pago' },
        { id: 2, name: 'Pendente' },
        { id: 3, name: 'Atrasado' }
      ];

    return listSituacao;
  }

